import render from 'client/render'
import messages from 'messages/en.ton.json'

render(messages)
